import { render } from "./Drug.vue?vue&type=template&id=7654c488&scoped=true"
import script from "./Drug.vue?vue&type=script&lang=js"
export * from "./Drug.vue?vue&type=script&lang=js"

import "./Drug.vue?vue&type=style&index=0&id=7654c488&lang=scss&scoped=true"

import exportComponent from "H:\\ideaProject\\vue\\fiveG-project\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7654c488"]])

export default __exports__